module.exports = __webpack_public_path__ + "static/media/paginate-right-arrow.09c69970.svg";